var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "d-flex justify-content-start p-1" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-grow-1",
              staticStyle: { "margin-top": "5px" },
            },
            [
              _c("h2", { staticClass: "text-bold-700 mb-0" }, [
                _vm._v(_vm._s(_vm.total)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.__("globals.views"))),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        !_vm.show_views && _vm.views.length !== 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-link font-small-3 ml-auto mt-auto p-05",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.show_views = true
                  },
                },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.__("globals.show_views")) + " "
                ),
                _c("i", { staticClass: "fa fa-chevron-down" }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.show_views && _vm.views.length !== 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-link font-small-3 ml-auto mt-auto p-05",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.show_views = false
                  },
                },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.__("globals.hide_views")) + " "
                ),
                _c("i", { staticClass: "fa fa-chevron-up" }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.show_views
          ? _c("div", { staticClass: "card" }, [
              _c("table", { staticClass: "table" }, [
                _c("thead", { staticClass: "thead-light" }, [
                  _c("tr", { staticClass: "bg-primary" }, [
                    _c("th", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__("globals.name")) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__("globals.views")) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.views, function (view) {
                    return _c("tr", [
                      _c("td", [
                        !view.user
                          ? _c("p", [
                              _vm._v(_vm._s(_vm.__("globals.deleted_user"))),
                            ])
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "/member/profiles/" + view.user.username,
                                },
                              },
                              [_vm._v(_vm._s(view.user.name))]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(view.total) +
                            "\n                        "
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "avatar bg-rgba-primary p-50 mr-1" }, [
      _c("div", { staticClass: "avatar-content" }, [
        _c("i", { staticClass: "feather icon-eye primary font-medium-5" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }